var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsvLogoBeyaz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159 44",
    style: {
      enableBackground: "new 0 0 159 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B1B0B2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    transform: "translate(9.048 -42.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    transform: "translate(55.235 0.613)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6387",
    x: 90.2,
    y: 42.2,
    className: "st0",
    width: 4.5,
    height: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    className: "st0",
    d: "M0.6,55.2v9.9h-5.1v-9.9l-4.5-13h5.4l1.6,6.4l1.7-6.4h5.4L0.6,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    className: "st0",
    d: "M10.7,65.2l-0.2-0.9c-0.9,1-2.1,1.4-3.4,1.3c-1.9,0-3.2-1.7-3.2-3.8l0-3 c0.1-4.8,6.6-3.4,6.6-6.9c0-0.8,0-1.4-0.9-1.4c-0.8,0-1.1,0.6-1.1,1.4v1.5H3.9v-1.5c0-3.1,2.7-4.6,5.7-4.6c3.9,0,5.6,2.2,5.6,4.5 v13.3L10.7,65.2z M10.4,56.4c-1.1,0.7-1.9,1.1-1.9,2.5V61c0,1,0.3,1.4,0.9,1.4s0.9-0.4,0.9-1.4V56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    className: "st0",
    d: "M28.9,60.5c0,2.8-0.5,5.1-3.5,5.1C24,65.7,22.7,65.1,22,64v5.4h-4.5V47.7H22l0,1.8 c0.6-1.4,2.1-2.3,3.6-2.1c2.5,0,3.3,2.4,3.3,4.6L28.9,60.5L28.9,60.5z M24,52.3c0-0.8-0.4-1.2-1-1.2c-0.6,0-1.1,0.5-1.1,1.3v8.2 c0,0.8,0.4,1.2,1,1.2c0.6,0,1.1-0.4,1.1-1.3V52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    className: "st0",
    d: "M31.1,65.2V47.7h4.5v17.4H31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    className: "st0",
    d: "M46.7,65.1l-3-8.1L43,58.3v6.8h-5.1v-23H43v7.1l3.3-7.1h5.1l-4.7,9.7l5.1,13.3L46.7,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    className: "st0",
    d: "M61.8,52.5c-1.1-0.4-4.2-0.5-4.2,2.3v10.3h-4.5V47.7h4.2l0,1.9c0.9-1.6,2.7-2.4,4.5-2.3 L61.8,52.5L61.8,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    className: "st0",
    d: "M74.5,60.8c0,3.5-2.4,4.8-5.7,4.8c-3,0-5.7-1.5-5.7-4.9v-8.1c0-3.3,2-5.2,5.7-5.2 c3,0,5.7,1.2,5.7,5.2v4.6h-6.7v4.2c0,0.7,0.3,1.1,1,1.1s1-0.4,1-1.1v-2.6h4.7L74.5,60.8L74.5,60.8z M69.8,51.6 c0-0.7-0.3-1.1-0.9-1.1c-0.7,0-1,0.4-1,1.1V54h2L69.8,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    className: "st0",
    d: "M83.5,65.2v-1.8c-0.4,1.5-1.9,2.1-3.6,2.1c-2.8,0-3.4-2.4-3.4-4.6v-8.5c0-2.8,0.7-5.2,3.5-5.2 c1.3-0.1,2.6,0.5,3.4,1.6v-6.7H88v23H83.5z M83.5,52.2c0-0.8-0.4-1.2-1.1-1.2c-0.6,0-1.1,0.4-1.1,1.2l0,8.3c0,0.8,0.4,1.2,1,1.2 c0.6,0,1.1-0.5,1.1-1.3L83.5,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    className: "st0",
    d: "M90.2,65.2V47.8h4.5v17.4H90.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    className: "st1",
    d: "M44.4,51.1c-2.9-8.4-11.3-8.9-12.2-8.9c-4.1-0.1-8.1,1.5-11.1,4.3c-1.2,1.2-2.3,2.5-3.1,3.9 l0,0l0,0c-0.9-1.4-1.9-2.7-3.1-3.9c-3-2.9-7-4.4-11.1-4.3c-0.9,0-9.3,0.5-12.2,8.9c-1.1,3.2-0.8,6.8,0.8,9.8c1.5,3.3,5.2,6,9.1,5.7 c3.1-0.1,5.8-2,7.1-4.8c1.1-2.6,0.5-5.6-1.5-7.6c0.1,0.7,0,1.5-0.5,2.1c-0.9,1.2-2.4,1.6-3.8,1C1.6,57,1,55.8,1.1,54.6 c0.2-1,0.8-1.9,1.8-2.2c1.7-0.7,3.3-0.4,4.8,1.1c2.5,2.8,2.8,7.1,4,10.3c0.8,2.7,2.2,5,5.1,5.7c0.4,0.1,0.7,0.1,1.1,0.1l0,0 c0.4,0,0.7,0,1.1-0.1c2.9-0.7,4.3-3,5.1-5.7c1.2-3.2,1.5-7.5,4-10.3c1.5-1.5,3.1-1.8,4.8-1.1c1,0.4,1.6,1.2,1.8,2.2 c0.2,1.2-0.5,2.3-1.6,2.7c-1.3,0.6-2.9,0.2-3.8-1c-0.4-0.6-0.6-1.4-0.5-2.1c-2,2-2.6,5-1.5,7.6c1.2,2.8,4,4.7,7.1,4.8 c3.9,0.3,7.6-2.4,9.2-5.7C45.2,57.9,45.5,54.3,44.4,51.1z M38.5,61.2c-1.6,1.5-4,2-6.1,1.2c-1.1-0.5-1.9-1.5-2.3-2.6 c1.6,1.6,4.5,2.4,7.2-0.4c0,0,2.5-2.3,1.1-6.7c-1-2.3-3.1-3.9-5.6-4.2c-3.3-0.6-6.7,0.8-8.6,3.6c-2.5,3.9-2.9,8.3-4.7,12.7 c-0.3,0.7-0.9,1.1-1.6,1l0,0c-0.7,0.1-1.4-0.4-1.6-1c-1.8-4.4-2.2-8.7-4.7-12.7c-1.9-2.8-5.2-4.2-8.6-3.6c-2.5,0.3-4.6,1.9-5.6,4.2 c-1.4,4.4,1.1,6.7,1.1,6.7c2.7,2.8,5.6,2,7.2,0.4c-0.3,1.2-1.2,2.1-2.3,2.6c-2.1,0.8-4.5,0.4-6.1-1.2c-2.4-2.4-3.2-5.9-2-9.1 c1.3-3.8,5.1-5.6,8.1-5.9c3.6-0.3,8.5,1.9,10.5,5.6c0.5,0.9,1.4,3.1,1.4,3.1H18h2.5c0,0,1-2.2,1.4-3.1c2-3.7,6.9-5.9,10.5-5.6 c3,0.2,6.8,2.1,8.1,5.9C41.7,55.2,40.9,58.8,38.5,61.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5190",
    transform: "translate(68.501 -10.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    className: "st0",
    d: "M-5,44.3c0-0.7-0.4-1.2-1.6-1.2c-1.2,0-1.6,0.5-1.6,1.2v0.6c0,0.5,0.3,0.9,0.7,1.1l2.1,1 c0.7,0.3,1.2,0.9,1.2,1.7v1.3c0,1-0.6,1.9-2.5,1.9S-9,50.9-9,49.9v-0.8c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2v0.7 c0,0.7,0.4,1.2,1.6,1.2c1.2,0,1.6-0.5,1.6-1.2v-1c0-0.7-0.5-1-1-1.2l-2-0.9C-8.5,46.4-9,45.8-9,45.1v-0.8c0-1,0.5-1.9,2.4-1.9 s2.4,0.9,2.4,1.9V45c0,0.1,0,0.2-0.1,0.2c0,0,0,0-0.1,0h-0.5C-4.9,45.2-5,45.1-5,45L-5,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    className: "st0",
    d: "M-2.5,46.5c0-1,0.5-1.6,2.1-1.6c1.6,0,2.1,0.7,2.1,1.6v5c0,0.1,0,0.2-0.2,0.2H1.1 c-0.1,0-0.2-0.1-0.2-0.2l0-0.4c-0.5,0.5-1.2,0.7-1.9,0.7c-0.8,0.1-1.5-0.4-1.6-1.2c0-0.1,0-0.2,0-0.2v-0.9c0-0.8,0.6-1.5,1.4-1.5 c0.1,0,0.1,0,0.2,0h1.9v-1.4c0-0.6-0.3-0.9-1.3-0.9s-1.3,0.4-1.3,0.9v0.3c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2 L-2.5,46.5z M0.8,50.4v-1.8h-1.7c-0.4-0.1-0.9,0.2-0.9,0.7c0,0.1,0,0.2,0,0.2v0.6c0,0.6,0.3,0.9,1,0.9C-0.2,51,0.4,50.8,0.8,50.4 L0.8,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    className: "st0",
    d: "M3.4,50.2v-3.8c-0.1-0.8,0.5-1.5,1.3-1.5c0.1,0,0.2,0,0.3,0c0.7,0,1.4,0.3,2,0.7l0-0.4 C7,45.1,7,45,7.2,45h0.4c0.1,0,0.2,0.1,0.2,0.2v7.5c0,1-0.6,1.6-2.2,1.6H4c-0.1,0-0.2-0.1-0.2-0.2v-0.4c0-0.1,0.1-0.2,0.2-0.2h1.6 c1,0,1.3-0.4,1.3-1v-1.6c-0.5,0.5-1.2,0.7-1.9,0.7c-0.8,0.1-1.5-0.5-1.6-1.2C3.4,50.4,3.4,50.3,3.4,50.2z M4.7,42.8 c0,0.5,0.1,0.9,0.8,0.9s0.8-0.4,0.8-0.9v-0.3c0-0.1,0-0.2,0.2-0.2h0.3c0.1,0,0.2,0.1,0.2,0.2v0.3c0.1,0.7-0.4,1.3-1.1,1.5 c-0.1,0-0.2,0-0.4,0c-1.1,0-1.4-0.6-1.4-1.5v-0.3c0-0.1,0.1-0.2,0.2-0.2h0.3c0.1,0,0.2,0.1,0.2,0.2L4.7,42.8z M4.3,50.1 c0,0.5,0.3,0.9,1,0.9c0.6,0,1.2-0.3,1.7-0.7v-4c-0.5-0.4-1.1-0.7-1.7-0.7c-0.7,0-1,0.4-1,0.9V50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    className: "st0",
    d: "M10.5,51.5c0,0.1-0.1,0.2-0.2,0.2H9.8c-0.1,0-0.2-0.1-0.2-0.2v-9c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    className: "st0",
    d: "M13.2,51.5c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-6.3 c0-0.1,0.1-0.2,0.2-0.2H13c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    className: "st0",
    d: "M19.4,51.5c0.1,0.1,0,0.2-0.1,0.2h-0.7c-0.1,0-0.2-0.1-0.3-0.2l-2.1-3.2h-0.3v3.2 c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-9c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0.1,0h0.5c0.1,0,0.2,0,0.2,0.1 c0,0,0,0,0,0.1v5.1h0.4l1.9-2.4c0.1-0.1,0.2-0.2,0.3-0.2H19c0.1,0,0.2,0.1,0.1,0.2L17,47.9L19.4,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    className: "st0",
    d: "M23.4,51.7c-0.1,0-0.2-0.1-0.2-0.2v-8.8c0-0.1,0.1-0.2,0.2-0.2h3.9c0.1,0,0.2,0.1,0.2,0.2v0.4 c0,0.1-0.1,0.2-0.2,0.2h-3.2v3.2h3c0.1,0,0.2,0.1,0.2,0.2V47c0,0.1-0.1,0.2-0.2,0.2h-3v3.7h3.4c0.1,0,0.2,0,0.2,0.2v0.4 c0,0.1,0,0.2-0.1,0.2c0,0,0,0,0,0H23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    className: "st0",
    d: "M29.7,45c0.1,0,0.2,0.1,0.2,0.2l0,0.4c0.5-0.5,1.2-0.7,1.9-0.7c0.6-0.1,1.2,0.3,1.5,0.8 c0.5-0.5,1.3-0.8,2-0.8c0.8-0.1,1.5,0.5,1.6,1.3c0,0.1,0,0.2,0,0.2v5.1c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-4.9 c0-0.5-0.3-0.9-1-0.9c-0.6,0-1.2,0.3-1.6,0.7c0,0.1,0,0.2,0,0.2v4.9c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-4.9 c0-0.5-0.3-0.9-1-0.9c-0.6,0-1.2,0.2-1.6,0.7v5.1c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-6.3c0-0.1,0.1-0.2,0.2-0.2 L29.7,45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    className: "st0",
    d: "M42.9,48.3c0,0.1-0.1,0.2-0.2,0.2h-3.3v1.7c0,0.5,0.3,0.9,1.3,0.9c1,0,1.3-0.4,1.3-0.9v-0.4 c0-0.1,0.1-0.2,0.2-0.2h0.4c0.1,0,0.2,0.1,0.2,0.2v0.4c0,1-0.5,1.6-2.1,1.6s-2.1-0.7-2.1-1.6v-3.6c0-1,0.5-1.6,2.1-1.6 s2.1,0.7,2.1,1.6L42.9,48.3z M39.5,47.8h2.6v-1.3c0-0.5-0.3-0.9-1.3-0.9s-1.3,0.4-1.3,0.9L39.5,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    className: "st0",
    d: "M49,51.5c0.1,0.1,0,0.2-0.1,0.2h-0.6c-0.1,0-0.2-0.1-0.3-0.2l-2.1-3.2h-0.4v3.2 c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0v-9c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0.1,0h0.5c0.1,0,0.2,0,0.2,0.1 c0,0,0,0,0,0.1v5.1h0.4l1.9-2.4c0.1-0.1,0.2-0.2,0.3-0.2h0.6c0.1,0,0.2,0.1,0.1,0.2l-2.2,2.7L49,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    className: "st0",
    d: "M50.9,51.5c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-9c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4354",
    className: "st0",
    d: "M53.6,43.7c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-1.3c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V43.7z M53.6,51.5c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-6.3c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    className: "st0",
    d: "M56.3,51.5c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-9c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4356",
    className: "st0",
    d: "M59,43.7c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-1.3c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V43.7z M59,51.5c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-6.3c0-0.1,0.1-0.2,0.2-0.2h0.5 c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4357",
    className: "st0",
    d: "M65.2,51.5c0.1,0.1,0,0.2-0.1,0.2h-0.6c-0.1,0-0.2-0.1-0.3-0.2L62,48.3h-0.4v3.2 c0,0.1-0.1,0.2-0.2,0.2H61c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0v-9c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0.1,0h0.5c0.1,0,0.2,0,0.2,0.1 c0,0,0,0,0,0.1v5.1H62l1.9-2.4c0.1-0.1,0.2-0.2,0.3-0.2h0.6c0.1,0,0.2,0.1,0.1,0.2l-2.2,2.7L65.2,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    className: "st0",
    d: "M70.6,51.7c-0.1,0-0.2-0.1-0.2-0.2l-2.3-8.8c0-0.1,0-0.2,0.1-0.2h0.6c0.1,0,0.2,0.1,0.2,0.2 l1.6,6.4c0.1,0.3,0.2,0.9,0.2,1.4c0.1-0.3,0.2-1,0.3-1.3l1.6-6.4c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0.5c0.1,0,0.2,0.1,0.2,0.2 l-2.3,8.8c0,0.1-0.1,0.2-0.2,0.2L70.6,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4359",
    className: "st0",
    d: "M74.4,46.5c0-1,0.5-1.6,2.1-1.6c1.6,0,2.1,0.7,2.1,1.6v5c0,0.1,0,0.2-0.2,0.2H78 c-0.1,0-0.2-0.1-0.2-0.2l0-0.4c-0.5,0.5-1.2,0.7-1.9,0.7c-0.8,0.1-1.5-0.4-1.6-1.2c0-0.1,0-0.2,0-0.2v-0.9c0-0.8,0.6-1.5,1.4-1.5 c0.1,0,0.1,0,0.2,0h1.9v-1.4c0-0.6-0.3-0.9-1.3-0.9s-1.3,0.4-1.3,0.9v0.3c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2 L74.4,46.5z M77.8,50.4v-1.8h-1.7c-0.4-0.1-0.9,0.2-0.9,0.7c0,0.1,0,0.2,0,0.2v0.6c0,0.6,0.3,0.9,1,0.9 C76.8,51,77.3,50.8,77.8,50.4L77.8,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4360",
    className: "st0",
    d: "M84.8,51.5c0.1,0.1,0,0.2-0.1,0.2H84c-0.1,0-0.2-0.1-0.3-0.2l-2.1-3.2h-0.4v3.2 c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0,0v-9c0-0.1,0-0.2,0.1-0.2c0,0,0,0,0.1,0h0.5c0.1,0,0.2,0,0.2,0.1 c0,0,0,0,0,0.1v5.1h0.4l1.9-2.4c0.1-0.1,0.2-0.2,0.3-0.2h0.6c0.1,0,0.2,0.1,0.1,0.2l-2.2,2.7L84.8,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    className: "st0",
    d: "M86.2,45v-1.2c0-1,0.6-1.6,2.2-1.6h0.1c0.1,0,0.2,0.1,0.2,0.2v0.4c0,0.1,0,0.2-0.1,0.2 c0,0,0,0-0.1,0h-0.1c-1,0-1.3,0.4-1.3,1V45h1.2c0.1,0,0.2,0,0.2,0.1c0,0,0,0,0,0.1v0.4c0,0.1,0,0.2-0.1,0.2c0,0,0,0-0.1,0h-1.2v5.7 c0,0.1-0.1,0.2-0.2,0.2h-0.5c-0.1,0-0.2-0.1-0.2-0.2v-5.7h-0.7c-0.1,0-0.2-0.1-0.2-0.2v-0.3c0-0.1,0.1-0.2,0.1-0.2c0,0,0,0,0,0 L86.2,45L86.2,45z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    className: "st0",
    d: "M90.5,51.5c0,0.1,0,0.2-0.1,0.2c0,0,0,0-0.1,0h-0.5c-0.1,0-0.2,0-0.2-0.1c0,0,0,0,0-0.1v-6.3 c0-0.1,0.1-0.2,0.2-0.2h0.5c0.1,0,0.2,0.1,0.2,0.2V51.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsvLogoBeyaz);
export default __webpack_public_path__ + "static/media/esv-logo-beyaz.0d06e39632eaf14d59c748aa8a4031c9.svg";
export { ForwardRef as ReactComponent };